// Other Dependencies:
// - languageSelectView.scss

import Backbone from "backbone";
import $ from "jquery";
import * as _ from "underscore";

import * as languageMap from "shared/languageMap";

const LanguageSelectView = Backbone.View.extend({
  /**
   * Allows user to select either their currentLearningLanguage or firstLanguage depending on the
   * @param field
   *
   * @param {User}    options.model
   * @param {string}  options.field
   * @param {boolean} options.switchToMonolingualIfSame - prevent user from setting both languages
   *                                                      the same, instead switch to monolingual
   *                                                      (readerTranslations to 'off')
   * @param {boolean} options.learningLanguages - if true, only show languages that can be used for
   *                                              learning
   * @param {boolean} options.disabled
   */
  initialize: function (options) {
    this.options = options || {};
    this.render();
    this.listenTo(
      this.model,
      "change:" + this.options.field,
      this.render.bind(this)
    );
    if (this.options.field === "firstLanguage") {
      this.listenTo(
        this.model,
        "change:readerTranslations",
        this.render.bind(this)
      );
    }
  },
  className: "languageSelectView",
  render: function () {
    if (!this.initialized) {
      this.$el.addClass(this.className);
      this.$select = $("<select></select>");
      this.$el.empty().append(this.$select);

      let list;
      if (this.options.learningLanguages) {
        list = languageMap.learningList;
      } else {
        list = languageMap.list;
      }

      _.each(list, (language) => {
        const option = $("<option/>").attr("data-languageCode", language.code);
        let text;
        if (this.options.english) {
          option.attr("title", language.name);
          text = language.english;
        } else {
          option.attr("title", language.english);
          text = language.name;
        }
        option.text(text);
        this.$select.append(option);
      });

      if (this.options.hint) {
        this.$select.attr("title", this.options.hint);
      }
      this.initialized = true;
    }

    this.selectAppropriateOption();

    if (
      this.options.field === "firstLanguage" &&
      this.model.get("readerTranslations") === "off"
    ) {
      this.$select.attr("disabled", true);

      // add invisible clickable area
      if (this.$(".invisibleClickableArea").length === 0) {
        this.$el.append('<div class="reEnableTranslation"/>');
      }
    } else {
      this.$select.removeAttr("disabled");

      // remove invisible clickable area
      this.$(".reEnableTranslation").remove();
    }

    if (this.options.disabled) {
      this.$select.attr("disabled", true);
    }
  },
  selectAppropriateOption: function () {
    this.$el
      .find(
        'option[data-languageCode="' + this.model.get(this.options.field) + '"]'
      )
      .prop("selected", true);
  },
  events: {
    "change select": "onChange",
    "click .reEnableTranslation": "reEnableTranslation",
  },
  onChange: function () {
    if (
      this.options.confirmationPrompt &&
      !confirm(this.options.confirmationPrompt)
    ) {
      this.selectAppropriateOption();
      return;
    }

    const selectedOption = this.$select.find("option:selected");
    const newCode = selectedOption.attr("data-languageCode");

    const complementaryField =
      this.options.field === "firstLanguage"
        ? "currentLearningLanguage"
        : "firstLanguage";
    if (newCode === this.model.get(complementaryField)) {
      if (this.options.switchToMonolingualIfSame) {
        this.model.save({
          readerTranslations:
            this.model.get("readerTranslations") === "on" ? "off" : "on",
        });
        return;
      }
      if (this.options.flipIfSame) {
        const newHash = {};
        newHash[this.options.field] = this.model.get(complementaryField);
        newHash[complementaryField] = this.model.get(this.options.field);
        this.model.save(newHash);
      }
    }

    const changed = {};
    changed[this.options.field] = newCode;

    this.model.save(changed, { patch: true });
    if (this.options.onChange) {
      this.options.onChange(newCode);
    }
  },
  reEnableTranslation: function (event) {
    if (
      this.options.switchToMonolingualIfSame &&
      this.model.get("readerTranslations") === "off"
    ) {
      this.model.save({ readerTranslations: "on" });
      event.preventDefault();
      event.stopPropagation();
    }
  },
});

export default LanguageSelectView;
